var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPlusNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.703,
    width: 46.593,
    height: 46.593,
    rx: 23.297,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.703,
    width: 46.593,
    height: 46.593,
    rx: 23.297,
    stroke: "#1600E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.788 17.06h-1.983v5.949h-5.95v1.982h5.95v5.95h1.983v-5.95h5.949V23.01h-5.95v-5.95z",
    fill: "#1600E5"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjcwMzM2OSIgd2lkdGg9IjQ2LjU5MzIiIGhlaWdodD0iNDYuNTkzMiIgcng9IjIzLjI5NjYiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjAuNSIgeT0iMC43MDMzNjkiIHdpZHRoPSI0Ni41OTMyIiBoZWlnaHQ9IjQ2LjU5MzIiIHJ4PSIyMy4yOTY2IiBzdHJva2U9IiMxNjAwRTUiLz4KICAgIDxwYXRoIGlkPSJ0b3AiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQuNzg3NyAxNy4wNTkzSDIyLjgwNDZWMjMuMDA4NUgxNi44NTU1VjI0Ljk5MTVIMjIuODA0NlYzMC45NDA3SDI0Ljc4NzdWMjQuOTkxNUgzMC43MzY4VjIzLjAwODVIMjQuNzg3N1YxNy4wNTkzWiIgZmlsbD0iIzE2MDBFNSIvPgoKPC9zdmc+Cg==";
export { SvgFaqPlusNew as ReactComponent };